import {
  AfterViewInit,
  Component,
  effect,
  forwardRef,
  inject,
  input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {debounceTime, finalize, map, Observable, of, Subject} from 'rxjs';
import {ProductGroupDetailDto} from '../../../../generated-model/model';
import {NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent} from '@ng-select/ng-select';
import {AsyncPipe, NgIf} from '@angular/common';
import {ProductDetailRest} from '../../../service/ProductDetailRest';

@Component({
  selector: 'app-product-group-detail-autocomplete',
  standalone: true,
  imports: [
    FormsModule,
    NgSelectComponent,
    AsyncPipe,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgIf
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductGroupDetailComponent),
      multi: true
    }
  ],
  templateUrl: './product-group-detail.component.html',
})
export class ProductGroupDetailComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnChanges {
  plants$: Observable<ProductGroupDetailDto[]> = of([]);
  term$ = new Subject<string>();
  typeaheadLoading = false;
  value: ProductGroupDetailDto = undefined;
  id = input<string>('product-group');
  name = input<string>('product-group');
  disabled = input<boolean>();
  touched = false;
  qrTracesId = input<string>()
  options = input<{ fetchAll?: boolean }>({fetchAll: false});
  isProduct = input<boolean>(false)
  @ViewChild('ngSelectComponent', {static: true, read: NgSelectComponent}) ngSelectComponent: NgSelectComponent;

  private productDetailService = inject(ProductDetailRest)

  onChange = (value: any) => {
  };
  onTouched = () => {
  };

  compareWithCode = (o1: any, o2: any): boolean => {
    return (o1 == o2) || ((!!o1 && !!o2) && (o1.id == o2.id))
  };

  ngAfterViewInit() {

  }

  constructor() {
    effect(() => {
      if (this.qrTracesId()) {
        this.term$
          .pipe(debounceTime(500))
          .subscribe(term => {
            this.typeaheadLoading = true;
            this.plants$ = this.productDetailService.searchAutocomplete(term, this.qrTracesId(),this.isProduct()).pipe(
              map(e => {
                return e;
              }),
              finalize(() => this.typeaheadLoading = false)
            )
          });
      }
    });
  }

  ngOnInit(): void {
  }

  writeValue(value: ProductGroupDetailDto) {
    this.value = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  valueChange(value: ProductGroupDetailDto) {
    this.onChange(value);
    this.onTouched();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onOpen() {
    this.term$.next('');
  }
}
